import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckHistoryUsers } from '@api/consistencyCheckParameters';

import { extractQueryParams } from '@utils/common';
import { mapDropdownOptions } from '@utils/formatter';

import { IId } from '@interfaces/common/common';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_CHECK_HISTORY_USERS } from '@constants/queryKeys';

interface IUseConsistencyCheckHistoryUsersReturned {
	consistencyCheckUsers: TSelectOption<string>[];
	isLoadingConsistencyCheckHistoryUsers: boolean;
}

const useConsistencyCheckHistoryUsers = ({ id }: IId): IUseConsistencyCheckHistoryUsersReturned => {
	const {
		data,
		isInitialLoading,
		isFetching,
	} = useQuery({
		queryKey: [CONSISTENCY_CHECK_HISTORY_USERS, { id }],
		queryFn: extractQueryParams(getConsistencyCheckHistoryUsers),
		select: (data) => mapDropdownOptions({
			items: data,
			valueKey: 'id',
			labelKey: 'name',
		}),
		enabled: [!!id],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		consistencyCheckUsers: data || [],
		isLoadingConsistencyCheckHistoryUsers: isInitialLoading || isFetching,
	};
};

export default useConsistencyCheckHistoryUsers;
